import {Dispatch, FC, SetStateAction, useState} from "react";
import {
  AssignLearnModuleAction,
  FlowAction,
  FlowTrigger
} from "../../../../../lib/src/api/repositories/flows-repository";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faTrash} from "@fortawesome/free-solid-svg-icons";
import {Select} from "../../../../../lib/src/components/form/Select";
import {Button} from "../../../../../lib/src/components/form/Button";
import {LearnModule} from "../../../../../lib/src/api/repositories/learn-repository";
import {ObjectAutocomplete} from "../../../../../lib/src/components/form/auto-complete/ObjectAutocomplete";

export const ActionsEditor: FC<{trigger: FlowTrigger, actions: FlowAction[], setActions: Dispatch<SetStateAction<FlowAction[]>>, learnModules: LearnModule[]}> = ({trigger, actions, setActions, learnModules}) => {
  const actionTypes: {[key: string]: string } = {
    'assign_learn_module': 'Kennisbank Module Toekennen',
    'send_welcome_email': 'Onboarding Mail Versturen',
  }
  const [addAction, setAddAction] = useState<string>(Object.keys(actionTypes)[0])

  return <div className={'flex flex-col items-stretch px-3'}>
    {actions.map((action, index) => {
      return <div key={index}>
        {index !== 0 && <>
          <div className={'ml-[calc(0.75rem-1px)] border-l-2 border-brand-primary-container h-4'}></div>
        </>}
        <div className={'rounded-lg bg-brand-primary-container text-brand-on-primary-container px-4 py-3'}>
          <div className={'flex justify-between'}>
            <h2 className={'font-medium'}>{actionTypes[action.type] ?? action.type}</h2>
            <button className={'text-brand-error'} type={'button'} onClick={() => setActions(actions.filter((_, i) => i !== index))}><FontAwesomeIcon icon={faTrash} /></button>
          </div>
          {action.type === 'assign_learn_module' && <AssignLearnModuleActionEditor learnModules={learnModules} action={action} setAction={(a) => {
            setActions(actions.map((v, i) => i === index ? a : v))
          }} />}
        </div>
      </div>
    })}
    <div className={'ml-[calc(0.75rem-1px)] border-l-2 border-brand-primary-container h-4'}></div>
    <div className={'text-brand-on-primary-container rounded-lg border-2 border-dashed bg-white border-brand-primary-container px-4 py-3'}>
      <h2 className={'font-medium'}>Actie toevoegen</h2>
      <div className={'flex flex-col gap-2 mt-2'}>
        <Select label={''} options={actionTypes} value={addAction} onChange={setAddAction} />
        <Button type={'secondary'} size={'sm'} text={'Toevoegen'} onClick={() => {
          if (addAction === 'assign_learn_module') {
            setActions([...actions, {type: 'assign_learn_module', params: {
              learn_module_id: learnModules[0]?.id ?? ''
            }}])
          }
          if (addAction === 'send_welcome_email') {
            setActions([...actions, {type: 'send_welcome_email', params: {}}])
          }
        }} />
      </div>
    </div>
  </div>
}

const AssignLearnModuleActionEditor: FC<{learnModules: LearnModule[], action: AssignLearnModuleAction, setAction: (v: FlowAction) => void}> = ({learnModules, action, setAction}) => {
  return <div>
    <ObjectAutocomplete label={'Module'} idProperty={'id'} value={learnModules.find(l => l.id === action.params.learn_module_id)!} options={learnModules} onChange={(v) => {
        setAction({...action, params: {...action.params, learn_module_id: v.id }})
    }} displayItem={(m) => m.name} />
  </div>
}